// components/LazyLoader/LazyLoader.jsx
import React, { useState, useEffect } from 'react';
import './LazyLoader.scss';

const LazyLoader = ({ embedded = false }) => {
  const loadingPhrases = [
    "Browsing our collection...",
    "Loading amazing products...",
    "Almost ready to shop...",
    "Preparing your store...",
    "Finding the best deals..."
  ];

  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % loadingPhrases.length);
    }, 2000); // Change message every 2 seconds

    return () => clearInterval(interval);
  }, [loadingPhrases.length]);

  return (
    <div className={`lazy-loader${embedded ? ' lazy-loader--embedded' : ''}`}>
      <div className="lazy-loader__content">
        <div className="lazy-loader__animation">
          {/* Shopping Cart Animation */}
          <div className="lazy-loader__shopping-cart">
            <svg viewBox="0 0 24 24" className="lazy-loader__cart-icon">
              <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-1.39-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
            </svg>
            {/* Floating Products */}
            <div className="lazy-loader__products">
              <div className="lazy-loader__product lazy-loader__product--1">
                <svg viewBox="0 0 24 24" className="lazy-loader__product-icon">
                  <rect x="3" y="3" width="18" height="18" rx="2" fill="currentColor" opacity="0.1"/>
                  <rect x="6" y="6" width="12" height="12" rx="1" fill="currentColor" opacity="0.3"/>
                </svg>
              </div>
              <div className="lazy-loader__product lazy-loader__product--2">
                <svg viewBox="0 0 24 24" className="lazy-loader__product-icon">
                  <circle cx="12" cy="12" r="9" fill="currentColor" opacity="0.1"/>
                  <circle cx="12" cy="12" r="5" fill="currentColor" opacity="0.3"/>
                </svg>
              </div>
              <div className="lazy-loader__product lazy-loader__product--3">
                <svg viewBox="0 0 24 24" className="lazy-loader__product-icon">
                  <polygon points="12,2 22,8 22,16 12,22 2,16 2,8" fill="currentColor" opacity="0.1"/>
                  <polygon points="12,6 18,10 18,14 12,18 6,14 6,10" fill="currentColor" opacity="0.3"/>
                </svg>
              </div>
            </div>
          </div>
          
          {/* Progress Indicator */}
          <div className="lazy-loader__progress">
            <div className="lazy-loader__bar"></div>
          </div>

          {/* Loading Message */}
          <div className="lazy-loader__message">
            <span className="lazy-loader__phrase">{loadingPhrases[currentPhraseIndex]}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LazyLoader;
